import React from "react";
import { uniq } from "lodash";
import { Icon } from "react-onsenui";
import ReactionColorCircle from "./ReactionColorCircle";
import SubstancePage from "../../pages/SubstancePage";
import Substance from "../substance/Substance";
import { getReagent } from "../../services/megamix";

const withDummyResults = (results, queries) => {
  const reagentIdsFromResults = uniq(results.map(r => r.reagent.id));
  const reagentIdsFromQueries = uniq(queries.map(q => q.reagentId));
  const missingReagentIds = reagentIdsFromQueries.filter(
    reagentId => !reagentIdsFromResults.includes(reagentId)
  );
  if (missingReagentIds.length === 0) {
    return results;
  }

  const dummyResults = missingReagentIds.map(reagentId => {
    return {
      isDummy: true,
      reagent: getReagent(reagentId),
      colors: [],
      hint: null,
      isReacting: null
    };
  });

  const newResults = results.concat(dummyResults);

  newResults.sort((resultA, resultB) => resultA.reagent.id - resultB.reagent.id);

  return newResults;
};

export default class ReactionItem extends React.Component {
  state = {};

  onReactionClick(event) {
    const { substance, navigator } = this.props;

    if (this.props.NoOnsen) {
      this.setState({showSubstancePage: !this.state.showSubstancePage});
    } else {
      navigator.pushPage({
        component: SubstancePage,
        props: {
          key: "substance-" + substance.id,
          substance: substance
        }
      });
    }
  }

  renderResultTds() {
    const { results, queries } = this.props;
    const filledResults = withDummyResults(results, queries);
    let resultsGrouped = {};
    //let resultsGrouped = Object.groupBy(filledResults, result => result.reagent.id);
    filledResults.forEach(result => {
      if (resultsGrouped[result.reagent.id] == null)
        resultsGrouped[result.reagent.id] = [];

      resultsGrouped[result.reagent.id].push(result);
    })
    return Object.values(resultsGrouped).map(this.renderResultTd);
  }

  renderResultTd(results, index) {
    return <div key={index} className={"testdrugs-reaction-color-circles"}>
      { results.map((result, i) => <ReactionColorCircle key={i} result={result} useShortReagentName={true} hideReagentNameOnLargeScreen={true} />) }
    </div>;
  }

  renderSubstancePage(show) {
    if (show) {
      return <Substance substance={this.props.substance} onClick={(e) => this.onReactionClick(e, true)} />;
    } else {
      return <div></div>;
    }
  }

  render() {
    const isOpen = this.state.showSubstancePage;
    const resultTds = this.renderResultTds();
    const { substance } = this.props;

    const className = "testdrugs-reactions-reaction" + (isOpen ? " open" : "");
    return (
      <div className={className}>

        <div className="testdrugs-reaction-header clickable" onClick={(e) => this.onReactionClick(e)}>
        <div className="testdrugs-reaction-name">
        <Icon icon={isOpen ? "fa-chevron-up" : "fa-chevron-down"} size={12} className="testdrugs-icon-openclose"/>
        {substance.name}
            {/* {substance.sid == null ? null : (
                      <Icon
                        className="testdrugs-icon-info"
                        icon="info-circle"
                        size={14}
                      />)} */}
          </div>

          <div className="testdrugs-reaction-colors">
            {resultTds}
          </div>
        </div>

        <div className="testdrugs-reaction-content">
          <div className="testdrugs-reaction-content-margin clickable" onClick={(e) => this.onReactionClick(e)}>
          </div>
          <div className="testdrugs-reaction-content-proper">
            {this.renderSubstancePage(isOpen)}
          </div>
        </div>
      </div>
    );
  }
}
